"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Generated API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertfanPropertiesApi = exports.AlertfanPropertiesApiFactory = exports.AlertfanPropertiesApiFp = exports.AlertfanPropertiesApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * AlertfanPropertiesApi - axios parameter creator
 * @export
 */
const AlertfanPropertiesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} property
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProperty: (property_1, ...args_1) => __awaiter(this, [property_1, ...args_1], void 0, function* (property, options = {}) {
            // verify required parameter 'property' is not null or undefined
            (0, common_1.assertParamExists)('deleteProperty', 'property', property);
            const localVarPath = `/alertfan/properties/{property}`
                .replace(`{${"property"}}`, encodeURIComponent(String(property)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} property
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProperty: (property_2, ...args_2) => __awaiter(this, [property_2, ...args_2], void 0, function* (property, options = {}) {
            // verify required parameter 'property' is not null or undefined
            (0, common_1.assertParamExists)('getProperty', 'property', property);
            const localVarPath = `/alertfan/properties/{property}`
                .replace(`{${"property"}}`, encodeURIComponent(String(property)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} property
         * @param {string} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setProperty: (property_3, body_1, ...args_3) => __awaiter(this, [property_3, body_1, ...args_3], void 0, function* (property, body, options = {}) {
            // verify required parameter 'property' is not null or undefined
            (0, common_1.assertParamExists)('setProperty', 'property', property);
            const localVarPath = `/alertfan/properties/{property}`
                .replace(`{${"property"}}`, encodeURIComponent(String(property)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.AlertfanPropertiesApiAxiosParamCreator = AlertfanPropertiesApiAxiosParamCreator;
/**
 * AlertfanPropertiesApi - functional programming interface
 * @export
 */
const AlertfanPropertiesApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.AlertfanPropertiesApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} property
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProperty(property, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteProperty(property, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AlertfanPropertiesApi.deleteProperty']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} property
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProperty(property, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getProperty(property, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AlertfanPropertiesApi.getProperty']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} property
         * @param {string} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setProperty(property, body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.setProperty(property, body, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AlertfanPropertiesApi.setProperty']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.AlertfanPropertiesApiFp = AlertfanPropertiesApiFp;
/**
 * AlertfanPropertiesApi - factory interface
 * @export
 */
const AlertfanPropertiesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.AlertfanPropertiesApiFp)(configuration);
    return {
        /**
         *
         * @param {AlertfanPropertiesApiDeletePropertyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProperty(requestParameters, options) {
            return localVarFp.deleteProperty(requestParameters.property, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AlertfanPropertiesApiGetPropertyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProperty(requestParameters, options) {
            return localVarFp.getProperty(requestParameters.property, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AlertfanPropertiesApiSetPropertyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setProperty(requestParameters, options) {
            return localVarFp.setProperty(requestParameters.property, requestParameters.body, options).then((request) => request(axios, basePath));
        },
    };
};
exports.AlertfanPropertiesApiFactory = AlertfanPropertiesApiFactory;
/**
 * AlertfanPropertiesApi - object-oriented interface
 * @export
 * @class AlertfanPropertiesApi
 * @extends {BaseAPI}
 */
class AlertfanPropertiesApi extends base_1.BaseAPI {
    /**
     *
     * @param {AlertfanPropertiesApiDeletePropertyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertfanPropertiesApi
     */
    deleteProperty(requestParameters, options) {
        return (0, exports.AlertfanPropertiesApiFp)(this.configuration).deleteProperty(requestParameters.property, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AlertfanPropertiesApiGetPropertyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertfanPropertiesApi
     */
    getProperty(requestParameters, options) {
        return (0, exports.AlertfanPropertiesApiFp)(this.configuration).getProperty(requestParameters.property, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AlertfanPropertiesApiSetPropertyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertfanPropertiesApi
     */
    setProperty(requestParameters, options) {
        return (0, exports.AlertfanPropertiesApiFp)(this.configuration).setProperty(requestParameters.property, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AlertfanPropertiesApi = AlertfanPropertiesApi;
//# sourceMappingURL=alertfan-properties-api.js.map